/**
 * The basic portal is the SAME build as the dashboard, switched by
 * hostname: client.mysmartfi.ph renders the buyer's portal instead of
 * the operator app. For staging/local testing (no dedicated host),
 * ?clientPortal=1 turns the mode on for the tab (?clientPortal=0 off).
 */
export function resolveClientPortalMode(
   hostname: string,
   search: string,
   store: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>
): boolean {
   if (hostname === 'client.mysmartfi.ph') return true;
   const q = new URLSearchParams(search);
   if (q.get('clientPortal') === '1') {
      store.setItem('sf.clientPortal', '1');
      return true;
   }
   if (q.get('clientPortal') === '0') {
      store.removeItem('sf.clientPortal');
      return false;
   }
   return store.getItem('sf.clientPortal') === '1';
}

export function isClientPortalHost(): boolean {
   try {
      return resolveClientPortalMode(
         window.location.hostname,
         window.location.search,
         sessionStorage
      );
   } catch {
      return false;
   }
}
